module.exports = __webpack_public_path__ + "static/media/roborregos_github.0ba2aa20.jpg";